(function () {
    'use strict';
    $(document).ready(function () {        

        new Rellax('.rellax', {
            center: true
        });


        $('.scroll-down').on('click', function () {
            $("html, body").animate({
                scrollTop: $('section.tools').offset().top - 60
            }, 1000);
        });

        $('.js-demo-popup-show').on('click', function (e) {
            e.preventDefault();
            $('.js-demo-popup').fadeIn();
        });

        $('.js-demo-popup-hide').on('click', function () {
            $('.js-demo-popup').fadeOut();
        });

        var swiperCustomersNav = new Swiper('.homepage .swiper-customers-nav', {
            slidesPerView: 6,
            spaceBetween: 0,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                },
                576: {
                    slidesPerView: 2,
                }
            }
        });

        var swiperCustomers = new Swiper('.homepage .swiper-customers', {
            spaceBetween: 30,
            autoHeight: true,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                576: {
                    autoHeight: true
                }
            },
        });

        var swiperContentTabs = new Swiper('.homepage .swiper-content-tabs', {
            spaceBetween: 30,
            slidesPerView: 3,
            breakpoints: {
                767: {
                    slidesPerView: 1,
                }
            },
        });

    });
}(jQuery));
